module.exports = __webpack_public_path__ + "img/map_upper-reserved.52f34957.jpg";